import {
  ADD_TRANSACTION,
  ADD_TRANSACTION_FAIL,
  ADD_TRANSACTION_SUCCESS,
  GET_ALL_TRANSACTION,
  GET_ALL_TRANSACTION_FAIL,
  GET_ALL_TRANSACTION_SUCCESS,
  ADD_PHYSICAL_TRANSACTION,
  ADD_PHYSICAL_TRANSACTION_SUCCESS,
  ADD_PHYSICAL_TRANSACTION_FAIL,
  GET_ALL_TRANSATIONS_FROM_USER_ID,
  GET_ALL_TRANSATIONS_FROM_USER_ID_FAIL,
  GET_ALL_TRANSATIONS_FROM_USER_ID_SUCCESS,
  GET_PARTICULAR_TRANSACTION,
  GET_PARTICULAR_TRANSACTION_FAIL,
  GET_PARTICULAR_TRANSACTION_SUCCESS,
  GET_USER_EARNING_FROM_USER_ID,
  GET_USER_EARNING_FROM_USER_ID_FAIL,
  GET_USER_EARNING_FROM_USER_ID_SUCCESS,
} from "./actionTypes";

export const getParticulartransaction = (data) => ({
  type: GET_PARTICULAR_TRANSACTION,
  payload: data,
});
export const getParticulartransactionSuccess = (data) => ({
  type: GET_PARTICULAR_TRANSACTION_SUCCESS,
  payload: data,
});
export const getParticulartransactionFail = (error) => ({
  type: GET_PARTICULAR_TRANSACTION_FAIL,
  payload: error,
});

export const getAlltransaction = (data, callback) => ({
  type: GET_ALL_TRANSACTION,
  payload: { data, callback },
});
export const getAlltransactionSuccess = (data) => ({
  type: GET_ALL_TRANSACTION_SUCCESS,
  payload: data,
});
export const getAlltransactionFail = (error) => ({
  type: GET_ALL_TRANSACTION_FAIL,
  payload: error,
});

export const addTransaction = (data, callback) => ({
  type: ADD_TRANSACTION,
  payload: { data, callback },
});
export const addTransactionSuccess = (data) => ({
  type: ADD_TRANSACTION_SUCCESS,
  payload: data,
});
export const addTransactionFail = (error) => ({
  type: ADD_TRANSACTION_FAIL,
  payload: error,
});

export const addPhysicalTransaction = (data, callback) => ({
  type: ADD_PHYSICAL_TRANSACTION,
  payload: { data, callback },
});
export const addPhysicalTransactionSuccess = (data) => ({
  type: ADD_PHYSICAL_TRANSACTION_SUCCESS,
  payload: data,
});
export const addPhysicalTransactionFail = (error) => ({
  type: ADD_PHYSICAL_TRANSACTION_FAIL,
  payload: error,
});

export const getTransactionFromUserId = (data, callback) => ({
  type: GET_ALL_TRANSATIONS_FROM_USER_ID,
  payload: { data, callback },
});
export const getTransactionFromUserIdSuccess = (data) => ({
  type: GET_ALL_TRANSATIONS_FROM_USER_ID_SUCCESS,
  payload: data,
});
export const getTransactionFromUserIdFail = (error) => ({
  type: GET_ALL_TRANSATIONS_FROM_USER_ID_FAIL,
  payload: error,
});

export const getUserEarningFromUserId = (data, callback) => ({
  type: GET_USER_EARNING_FROM_USER_ID,
  payload: { data, callback },
});
export const getUserEarningFromUserIdSuccess = (data) => ({
  type: GET_USER_EARNING_FROM_USER_ID_SUCCESS,
  payload: data,
});
export const getUserEarningFromUserIdFail = (error) => ({
  type: GET_USER_EARNING_FROM_USER_ID_FAIL,
  payload: error,
});
